import { render, staticRenderFns } from "./membershipSystemLots.vue?vue&type=template&id=856b534a"
import script from "./membershipSystemLots.vue?vue&type=script&lang=js"
export * from "./membershipSystemLots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports